import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { clientStore } from 'apps/client/app';

import { Link } from 'core/routing';

import { conf } from 'apps/components/footer/config.yaml';

import Copyright from 'apps/components/footer/blocks/Copyright';
import Social from 'apps/components/footer/blocks/Social';
import ChinaICP from 'apps/components/footer/blocks/ChinaICP';
import ChinaMPSBRecord from 'apps/components/footer/blocks/ChinaMPSBRecord';

import {
  PrimaryContent,
  SecondaryNav,
  SecondaryItem,
  FooterSmallMainStyled,
  FooterSmallNav,
  ChinaIDsColumn,
} from './footer.styled';

const FooterSmall = props => {
  const { chinaMode } = props;
  const { signedInProfile } = clientStore;
  const secondaryNavLinks = Array.from(conf.secondaryNav.entries());

  const RoutesListSmall = () => {
    return (
      <SecondaryNav>
        {secondaryNavLinks.map(([i, item]) => {
          if (!item.link) {
            return (
              <SecondaryItem key={i} link={item.link}>
                <Trans>{item.text}</Trans>
              </SecondaryItem>
            );
          }
          // FIXME - Point "About" page to Home/Landing
          const linkName =
            !signedInProfile && item.link === 'home.home' ? 'home' : item.link;

          return (
            <SecondaryItem key={i}>
              <Link name={linkName} to={linkName} params={item.params}>
                <Trans>{item.text}</Trans>
              </Link>
            </SecondaryItem>
          );
        })}
      </SecondaryNav>
    );
  };

  return (
    <FooterSmallMainStyled>
      <FooterSmallNav>
        <PrimaryContent>
          <Copyright />
          <ChinaMPSBRecord mobile chinaMode={chinaMode} />
          <ChinaICP mobile chinaMode={chinaMode} />
          <RoutesListSmall />
          {chinaMode && (
            <ChinaIDsColumn>
              <ChinaICP />
              <ChinaMPSBRecord />
            </ChinaIDsColumn>
          )}
          <Social hideText grey />
        </PrimaryContent>
      </FooterSmallNav>
    </FooterSmallMainStyled>
  );
};

FooterSmall.propTypes = {
  chinaMode: PropTypes.bool,
};

export default withNamespaces()(observer(FooterSmall));
